export var randomId = function (length) {
    if (length === void 0) { length = 8; }
    return Math.random()
        .toString(36)
        .substr(2, length);
};
//# sourceMappingURL=random.js.map